module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY7.3181874e.jpg";